export const state = () => ({
  guideModal: false,
  newDesign: true,
  notification: [],
  relationID: '',
  webVersion: process.env.VERSION || '1.0',
  paymentType: {
    PAYMENT_TYPE_VA_BCA: 'VirtualAccount',
    PAYMENT_TYPE_CC: 'VISA',
    PAYMENT_TYPE_DANA: 'Dana',
    PAYMENT_TYPE_OVO: 'Ovo',
    PAYMENT_TYPE_LINKAJA: 'Link Aja',
    PAYMENT_TYPE_MIDTRANS: 'Midtrans'
  }
})

export const mutations = {
  SET_OPEN_GUIDE_MODAL: (state, data) => {
    state.guideModal = data
  },
  SET_RELATION_ID: (state, data) => {
    state.relationID = data
  },
  SET_NOTIFICATION: (state, data) => {
    state.notification = data
  }

}

export const actions = {
  getNotifications ({ rootState }, params) {
    return new Promise((resolve, reject) => {
      this.$api.get(rootState.user.auth.role_endpoint + `notifications?${params}`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updateNotification ({ rootState }, id) {
    return new Promise((resolve, reject) => {
      this.$api.post(rootState.user.auth.role_endpoint + `notifications/read/${id}`, null)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getFaq () {
    return new Promise((resolve, reject) => {
      this.$api.get('public/ysp/faq')
        .then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getVideoTutorial ({ rootState }) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + rootState.user.auth.role_endpoint + 'help/page/video', {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  unFlag ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$api.post(rootState.user.auth.role_endpoint + 'unflag/help/page', payload)
        .then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  searchHelp ({ commit }, query) {
    return new Promise((resolve, reject) => {
      this.$api.get('public/ysp/help?q=' + query)
        .then(function (response) {
          resolve(response)
        }).catch(function (error) {
          const err = error.response
          reject(err)
        })
    })
  },
  searchICD ({ rootState }, query) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + 'public/medicine/icd-10' + query.pagination + query.search, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }).then(function (response) {
        resolve(response)
      }).catch(function (error) {
        const err = error.response
        reject(err)
      })
    })
  }
}
